import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["userId", "userName", "userHasPermission", "userGroups"])
  },
  methods: {
    filterUsers(users, role) {
      const newUsers = [];
      for (const user of users) {
        const epradmin = user.groups.filter(e => e.name === role);
        if (epradmin.length > 0) {
          newUsers.push(user);
        }
      }
      return newUsers;
    }
  }
};
